module.exports = __webpack_public_path__ + "animoji6.362deb6293.png";